module.exports = {
          srcSet: __webpack_public_path__ + "3532b28e9b3c5faddfdb12d765a4daac-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "3532b28e9b3c5faddfdb12d765a4daac-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "3532b28e9b3c5faddfdb12d765a4daac-60.png",
          toString:function(){return __webpack_public_path__ + "3532b28e9b3c5faddfdb12d765a4daac-60.png"},
          
          width: 60,
          height: 60
        }